module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/product_list_top.png";